// extracted by mini-css-extract-plugin
export default {"notes__loading":"Loading_notes__loading__MeWHb","loader":"Loading_loader__rS1ky","l2":"Loading_l2__CG02R"};